import Grid from '@material-ui/core/Grid';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from '@material-ui/core/ListItemIcon';
import withStyles from '@material-ui/core/styles/withStyles';
import InboxIcon from '@material-ui/icons/Inbox';
import { withSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from '../../../../../../Actions/AxiosInstance';

class ExpenseType extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DefaultExpenseCategories: [],
      selectedExpenseType: null,
    };

    this.getExpenseTypes = this.getExpenseTypes.bind(this);
  }

  componentDidMount() {
    this.GetDefaultExpenseCategory();
  }

  GetDefaultExpenseCategory() {
    instance.get("expense/getexpensetype")
      .then((result) => {
        let DefaultExpenseCategories = [];
        if (result.data.result.length > 0) {
          DefaultExpenseCategories = result.data.result;
        }
        this.setState({ DefaultExpenseCategories, selectedExpenseType: DefaultExpenseCategories[0].expensetype });
      }).catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: 'error' });
      });
  }

  getExpenseTypes(category) {
    this.setState({ selectedExpenseType: category.expensetype && category.expensetype });
  }

  render() {
        return (
            <div className="content-outer-wrapper">
                <Grid container className="expense-outer" >
                    <Grid item xs={12} md={12} sm={12}>
                        <div>
                            <span className="page-header-name-light">Expense Type and Categories</span>
                            <span className="page-subheader-name">Create and modify your expense categories and their types</span>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={12} sm={12}>
                        <Grid container>
                            <Grid item xs={12} md={3} sm={12} style={{ position: "relative", left: 1 }}>
                                <div>
                                    <List className="padding-top-0">
                                        {this.state.DefaultExpenseCategories && this.state.DefaultExpenseCategories.map((category) => (
                                            <ListItem className={this.state.selectedExpenseType && this.state.selectedExpenseType ? "selected-div" : "default-expense-category"} button onClick={() => this.getExpenseTypes(category)}>
                                                {category.categoryname}
                                            </ListItem>
                                          ))
                                      }

                                        {/* <ListItem button>
                                            Custom category
                                            <ListItemIcon>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                                    <path fill="#f60038" fill-rule="evenodd" d="M6.565 0a.696.696 0 0 0-.695.696H1.696a.696.696 0 0 0 0 1.391h12.521a.696.696 0 0 0 0-1.391h-4.174A.696.696 0 0 0 9.348 0H6.565zM2.043 3.478l1.255 11.284A1.39 1.39 0 0 0 4.679 16h6.555a1.39 1.39 0 0 0 1.381-1.238L13.87 3.478H2.043z"/>
                                                </svg>
                                            </ListItemIcon>
                                        </ListItem> */}
                                    </List>
                                    {/* <div button>
                                        <div>
                                            <span style={{color:"#1e8ced"}}>Add Category</span>
                                            <Add style={{height:16, width:16, marginLeft:16, borderRadius:16, background:"#1e8ced", color:"#fff"}}></Add>
                                        </div>
                                        <div style={{height:40}}>
                                            <TextField
                                                className="expense-category-input"
                                                // value={this.state.addressTypeName}
                                                type="text"
                                                margin="normal"
                                                variant="outlined"
                                                placeholder="Add custom type"
                                            />
                                            <Add className="expense-category-add-btn"></Add>
                                        </div>
                                    </div> */}
                                </div>
                            </Grid>
                            <Grid item xs={12} md={6} sm={12}>
                                <div className="expense-type-outer" >
                                    <div className="expense-types">
                                        <div className="default-expense-types">
                                            <div>
                                                <div className="custom-divider"></div>
                                                <div className="type-heading">Default types</div>
                                            </div>
                                            <List className="default-expense-types-list">


                                                  {this.state.selectedExpenseType && this.state.selectedExpenseType.map((expensetype) => (
                                                      <ListItem className="default-expense-types-list-item" button>
                                                        <ListItemIcon>
                                                          <InboxIcon />
                                                        </ListItemIcon>
                                                          {expensetype.subcategoryname}
                                                      </ListItem>
                                                    ))

                                                  }

                                            </List>
                                        </div>
                                        {/*
                                        // Custum type ui //
                                        <div className="custom-expense-types">
                                            <div>
                                                <div className="custom-divider"></div>
                                                <div className="type-heading">Custom types</div>
                                            </div>
                                            <List className="custom-expense-types-list">
                                                <ListItem className="custom-expense-types-list-item" button>
                                                    <ListItemIcon>
                                                        <InboxIcon />
                                                    </ListItemIcon>
                                                    Airfare
                                                    <ListItemSecondaryAction>
                                                        <InboxIcon />
                                                    </ListItemSecondaryAction>
                                                </ListItem>
                                                <ListItem className="custom-expense-types-list-item" button>
                                                    <ListItemIcon>
                                                        <InboxIcon />
                                                    </ListItemIcon>
                                                    Train
                                                    <ListItemSecondaryAction>
                                                        <InboxIcon />
                                                    </ListItemSecondaryAction>
                                                </ListItem>
                                                <ListItem className="custom-expense-types-list-item" button>
                                                    <ListItemIcon>
                                                        <InboxIcon />
                                                    </ListItemIcon>
                                                    Bus
                                                    <ListItemSecondaryAction>
                                                        <InboxIcon />
                                                    </ListItemSecondaryAction>
                                                </ListItem>
                                            </List>
                                        </div> */}
                                    </div>

                                    {/*
                                    // Add custum types ui //
                                    <div>
                                        <div>
                                            <TextField
                                                className="expense-text-input"
                                                // value={this.state.addressTypeName}
                                                type="text"
                                                margin="normal"
                                                variant="outlined"
                                                placeholder="Add custom type"
                                            />
                                            <Add className="expense-type-add-btn"></Add>
                                        </div>
                                    </div> */}
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>

        );
    }
}

ExpenseType.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    });

const mapDispatchToProps = (dispatch) => bindActionCreators({
    }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles()(withSnackbar(ExpenseType)));
